import styled from 'styled-components';
import { desktop_breakpoint_extended } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const FaqCategoryContainerStyles = styled.div`
  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    margin: 0 auto;
    max-width: 1300px;
    padding-top: 96px;
    width: 86%;

    .faq-category {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
`;
